import { __assign as x } from "./index60.mjs";
import { ErrorKind as l } from "./index55.mjs";
import { TYPE as p, SKELETON_TYPE as R } from "./index57.mjs";
import { SPACE_SEPARATOR_REGEX as k } from "./index62.mjs";
import { parseDateTimeSkeleton as V } from "./index63.mjs";
import { parseNumberSkeletonFromString as B, parseNumberSkeleton as Y } from "./index64.mjs";
import { getBestPattern as q } from "./index65.mjs";
var A, K = new RegExp("^".concat(k.source, "*")), W = new RegExp("".concat(k.source, "*$"));
function a(t, r) {
  return { start: t, end: r };
}
var H = !!String.prototype.startsWith && "_a".startsWith("a", 1), Q = !!String.fromCodePoint, j = !!Object.fromEntries, z = !!String.prototype.codePointAt, J = !!String.prototype.trimStart, Z = !!String.prototype.trimEnd, $ = !!Number.isSafeInteger, tt = $ ? Number.isSafeInteger : function(t) {
  return typeof t == "number" && isFinite(t) && Math.floor(t) === t && Math.abs(t) <= 9007199254740991;
}, S = !0;
try {
  var rt = D("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  S = ((A = rt.exec("a")) === null || A === void 0 ? void 0 : A[0]) === "a";
} catch {
  S = !1;
}
var U = H ? (
  // Native
  (function(t, r, i) {
    return t.startsWith(r, i);
  })
) : (
  // For IE11
  (function(t, r, i) {
    return t.slice(i, i + r.length) === r;
  })
), d = Q ? String.fromCodePoint : (
  // IE11
  (function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    for (var i = "", s = t.length, o = 0, n; s > o; ) {
      if (n = t[o++], n > 1114111)
        throw RangeError(n + " is not a valid code point");
      i += n < 65536 ? String.fromCharCode(n) : String.fromCharCode(((n -= 65536) >> 10) + 55296, n % 1024 + 56320);
    }
    return i;
  })
), G = (
  // native
  j ? Object.fromEntries : (
    // Ponyfill
    (function(t) {
      for (var r = {}, i = 0, s = t; i < s.length; i++) {
        var o = s[i], n = o[0], e = o[1];
        r[n] = e;
      }
      return r;
    })
  )
), F = z ? (
  // Native
  (function(t, r) {
    return t.codePointAt(r);
  })
) : (
  // IE 11
  (function(t, r) {
    var i = t.length;
    if (!(r < 0 || r >= i)) {
      var s = t.charCodeAt(r), o;
      return s < 55296 || s > 56319 || r + 1 === i || (o = t.charCodeAt(r + 1)) < 56320 || o > 57343 ? s : (s - 55296 << 10) + (o - 56320) + 65536;
    }
  })
), it = J ? (
  // Native
  (function(t) {
    return t.trimStart();
  })
) : (
  // Ponyfill
  (function(t) {
    return t.replace(K, "");
  })
), st = Z ? (
  // Native
  (function(t) {
    return t.trimEnd();
  })
) : (
  // Ponyfill
  (function(t) {
    return t.replace(W, "");
  })
);
function D(t, r) {
  return new RegExp(t, r);
}
var L;
if (S) {
  var M = D("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  L = function(t, r) {
    var i;
    M.lastIndex = r;
    var s = M.exec(t);
    return (i = s[1]) !== null && i !== void 0 ? i : "";
  };
} else
  L = function(t, r) {
    for (var i = []; ; ) {
      var s = F(t, r);
      if (s === void 0 || X(s) || at(s))
        break;
      i.push(s), r += s >= 65536 ? 2 : 1;
    }
    return d.apply(void 0, i);
  };
var Et = (
  /** @class */
  (function() {
    function t(r, i) {
      i === void 0 && (i = {}), this.message = r, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!i.ignoreTag, this.locale = i.locale, this.requiresOtherClause = !!i.requiresOtherClause, this.shouldParseSkeletons = !!i.shouldParseSkeletons;
    }
    return t.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, t.prototype.parseMessage = function(r, i, s) {
      for (var o = []; !this.isEOF(); ) {
        var n = this.char();
        if (n === 123) {
          var e = this.parseArgument(r, s);
          if (e.err)
            return e;
          o.push(e.val);
        } else {
          if (n === 125 && r > 0)
            break;
          if (n === 35 && (i === "plural" || i === "selectordinal")) {
            var u = this.clonePosition();
            this.bump(), o.push({
              type: p.pound,
              location: a(u, this.clonePosition())
            });
          } else if (n === 60 && !this.ignoreTag && this.peek() === 47) {
            if (s)
              break;
            return this.error(l.UNMATCHED_CLOSING_TAG, a(this.clonePosition(), this.clonePosition()));
          } else if (n === 60 && !this.ignoreTag && O(this.peek() || 0)) {
            var e = this.parseTag(r, i);
            if (e.err)
              return e;
            o.push(e.val);
          } else {
            var e = this.parseLiteral(r, i);
            if (e.err)
              return e;
            o.push(e.val);
          }
        }
      }
      return { val: o, err: null };
    }, t.prototype.parseTag = function(r, i) {
      var s = this.clonePosition();
      this.bump();
      var o = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: p.literal,
            value: "<".concat(o, "/>"),
            location: a(s, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var n = this.parseMessage(r + 1, i, !0);
        if (n.err)
          return n;
        var e = n.val, u = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !O(this.char()))
            return this.error(l.INVALID_TAG, a(u, this.clonePosition()));
          var f = this.clonePosition(), h = this.parseTagName();
          return o !== h ? this.error(l.UNMATCHED_CLOSING_TAG, a(f, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: p.tag,
              value: o,
              children: e,
              location: a(s, this.clonePosition())
            },
            err: null
          } : this.error(l.INVALID_TAG, a(u, this.clonePosition())));
        } else
          return this.error(l.UNCLOSED_TAG, a(s, this.clonePosition()));
      } else
        return this.error(l.INVALID_TAG, a(s, this.clonePosition()));
    }, t.prototype.parseTagName = function() {
      var r = this.offset();
      for (this.bump(); !this.isEOF() && nt(this.char()); )
        this.bump();
      return this.message.slice(r, this.offset());
    }, t.prototype.parseLiteral = function(r, i) {
      for (var s = this.clonePosition(), o = ""; ; ) {
        var n = this.tryParseQuote(i);
        if (n) {
          o += n;
          continue;
        }
        var e = this.tryParseUnquoted(r, i);
        if (e) {
          o += e;
          continue;
        }
        var u = this.tryParseLeftAngleBracket();
        if (u) {
          o += u;
          continue;
        }
        break;
      }
      var f = a(s, this.clonePosition());
      return {
        val: { type: p.literal, value: o, location: f },
        err: null
      };
    }, t.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !ot(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, t.prototype.tryParseQuote = function(r) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        // '{', '<', '>', '}'
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (r === "plural" || r === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var i = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var s = this.char();
        if (s === 39)
          if (this.peek() === 39)
            i.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          i.push(s);
        this.bump();
      }
      return d.apply(void 0, i);
    }, t.prototype.tryParseUnquoted = function(r, i) {
      if (this.isEOF())
        return null;
      var s = this.char();
      return s === 60 || s === 123 || s === 35 && (i === "plural" || i === "selectordinal") || s === 125 && r > 0 ? null : (this.bump(), d(s));
    }, t.prototype.parseArgument = function(r, i) {
      var s = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(l.EXPECT_ARGUMENT_CLOSING_BRACE, a(s, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(l.EMPTY_ARGUMENT, a(s, this.clonePosition()));
      var o = this.parseIdentifierIfPossible().value;
      if (!o)
        return this.error(l.MALFORMED_ARGUMENT, a(s, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(l.EXPECT_ARGUMENT_CLOSING_BRACE, a(s, this.clonePosition()));
      switch (this.char()) {
        // Simple argument: `{name}`
        case 125:
          return this.bump(), {
            val: {
              type: p.argument,
              // value does not include the opening and closing braces.
              value: o,
              location: a(s, this.clonePosition())
            },
            err: null
          };
        // Argument with options: `{name, format, ...}`
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(l.EXPECT_ARGUMENT_CLOSING_BRACE, a(s, this.clonePosition())) : this.parseArgumentOptions(r, i, o, s);
        default:
          return this.error(l.MALFORMED_ARGUMENT, a(s, this.clonePosition()));
      }
    }, t.prototype.parseIdentifierIfPossible = function() {
      var r = this.clonePosition(), i = this.offset(), s = L(this.message, i), o = i + s.length;
      this.bumpTo(o);
      var n = this.clonePosition(), e = a(r, n);
      return { value: s, location: e };
    }, t.prototype.parseArgumentOptions = function(r, i, s, o) {
      var n, e = this.clonePosition(), u = this.parseIdentifierIfPossible().value, f = this.clonePosition();
      switch (u) {
        case "":
          return this.error(l.EXPECT_ARGUMENT_TYPE, a(e, f));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var h = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var P = this.clonePosition(), c = this.parseSimpleArgStyleIfPossible();
            if (c.err)
              return c;
            var m = st(c.val);
            if (m.length === 0)
              return this.error(l.EXPECT_ARGUMENT_STYLE, a(this.clonePosition(), this.clonePosition()));
            var b = a(P, this.clonePosition());
            h = { style: m, styleLocation: b };
          }
          var E = this.tryParseArgumentClose(o);
          if (E.err)
            return E;
          var v = a(o, this.clonePosition());
          if (h && U(h == null ? void 0 : h.style, "::", 0)) {
            var T = it(h.style.slice(2));
            if (u === "number") {
              var c = this.parseNumberSkeletonFromString(T, h.styleLocation);
              return c.err ? c : {
                val: { type: p.number, value: s, location: v, style: c.val },
                err: null
              };
            } else {
              if (T.length === 0)
                return this.error(l.EXPECT_DATE_TIME_SKELETON, v);
              var _ = T;
              this.locale && (_ = q(T, this.locale));
              var m = {
                type: R.dateTime,
                pattern: _,
                location: h.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? V(_) : {}
              }, w = u === "date" ? p.date : p.time;
              return {
                val: { type: w, value: s, location: v, style: m },
                err: null
              };
            }
          }
          return {
            val: {
              type: u === "number" ? p.number : u === "date" ? p.date : p.time,
              value: s,
              location: v,
              style: (n = h == null ? void 0 : h.style) !== null && n !== void 0 ? n : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var C = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(l.EXPECT_SELECT_ARGUMENT_OPTIONS, a(C, x({}, C)));
          this.bumpSpace();
          var y = this.parseIdentifierIfPossible(), N = 0;
          if (u !== "select" && y.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(l.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, a(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var c = this.tryParseDecimalInteger(l.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, l.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (c.err)
              return c;
            this.bumpSpace(), y = this.parseIdentifierIfPossible(), N = c.val;
          }
          var g = this.tryParsePluralOrSelectOptions(r, u, i, y);
          if (g.err)
            return g;
          var E = this.tryParseArgumentClose(o);
          if (E.err)
            return E;
          var I = a(o, this.clonePosition());
          return u === "select" ? {
            val: {
              type: p.select,
              value: s,
              options: G(g.val),
              location: I
            },
            err: null
          } : {
            val: {
              type: p.plural,
              value: s,
              options: G(g.val),
              offset: N,
              pluralType: u === "plural" ? "cardinal" : "ordinal",
              location: I
            },
            err: null
          };
        }
        default:
          return this.error(l.INVALID_ARGUMENT_TYPE, a(e, f));
      }
    }, t.prototype.tryParseArgumentClose = function(r) {
      return this.isEOF() || this.char() !== 125 ? this.error(l.EXPECT_ARGUMENT_CLOSING_BRACE, a(r, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, t.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var r = 0, i = this.clonePosition(); !this.isEOF(); ) {
        var s = this.char();
        switch (s) {
          case 39: {
            this.bump();
            var o = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(l.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, a(o, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            r += 1, this.bump();
            break;
          }
          case 125: {
            if (r > 0)
              r -= 1;
            else
              return {
                val: this.message.slice(i.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(i.offset, this.offset()),
        err: null
      };
    }, t.prototype.parseNumberSkeletonFromString = function(r, i) {
      var s = [];
      try {
        s = B(r);
      } catch {
        return this.error(l.INVALID_NUMBER_SKELETON, i);
      }
      return {
        val: {
          type: R.number,
          tokens: s,
          location: i,
          parsedOptions: this.shouldParseSkeletons ? Y(s) : {}
        },
        err: null
      };
    }, t.prototype.tryParsePluralOrSelectOptions = function(r, i, s, o) {
      for (var n, e = !1, u = [], f = /* @__PURE__ */ new Set(), h = o.value, P = o.location; ; ) {
        if (h.length === 0) {
          var c = this.clonePosition();
          if (i !== "select" && this.bumpIf("=")) {
            var m = this.tryParseDecimalInteger(l.EXPECT_PLURAL_ARGUMENT_SELECTOR, l.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (m.err)
              return m;
            P = a(c, this.clonePosition()), h = this.message.slice(c.offset, this.offset());
          } else
            break;
        }
        if (f.has(h))
          return this.error(i === "select" ? l.DUPLICATE_SELECT_ARGUMENT_SELECTOR : l.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, P);
        h === "other" && (e = !0), this.bumpSpace();
        var b = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(i === "select" ? l.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : l.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, a(this.clonePosition(), this.clonePosition()));
        var E = this.parseMessage(r + 1, i, s);
        if (E.err)
          return E;
        var v = this.tryParseArgumentClose(b);
        if (v.err)
          return v;
        u.push([
          h,
          {
            value: E.val,
            location: a(b, this.clonePosition())
          }
        ]), f.add(h), this.bumpSpace(), n = this.parseIdentifierIfPossible(), h = n.value, P = n.location;
      }
      return u.length === 0 ? this.error(i === "select" ? l.EXPECT_SELECT_ARGUMENT_SELECTOR : l.EXPECT_PLURAL_ARGUMENT_SELECTOR, a(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !e ? this.error(l.MISSING_OTHER_CLAUSE, a(this.clonePosition(), this.clonePosition())) : { val: u, err: null };
    }, t.prototype.tryParseDecimalInteger = function(r, i) {
      var s = 1, o = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (s = -1);
      for (var n = !1, e = 0; !this.isEOF(); ) {
        var u = this.char();
        if (u >= 48 && u <= 57)
          n = !0, e = e * 10 + (u - 48), this.bump();
        else
          break;
      }
      var f = a(o, this.clonePosition());
      return n ? (e *= s, tt(e) ? { val: e, err: null } : this.error(i, f)) : this.error(r, f);
    }, t.prototype.offset = function() {
      return this.position.offset;
    }, t.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, t.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, t.prototype.char = function() {
      var r = this.position.offset;
      if (r >= this.message.length)
        throw Error("out of bound");
      var i = F(this.message, r);
      if (i === void 0)
        throw Error("Offset ".concat(r, " is at invalid UTF-16 code unit boundary"));
      return i;
    }, t.prototype.error = function(r, i) {
      return {
        val: null,
        err: {
          kind: r,
          message: this.message,
          location: i
        }
      };
    }, t.prototype.bump = function() {
      if (!this.isEOF()) {
        var r = this.char();
        r === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += r < 65536 ? 1 : 2);
      }
    }, t.prototype.bumpIf = function(r) {
      if (U(this.message, r, this.offset())) {
        for (var i = 0; i < r.length; i++)
          this.bump();
        return !0;
      }
      return !1;
    }, t.prototype.bumpUntil = function(r) {
      var i = this.offset(), s = this.message.indexOf(r, i);
      return s >= 0 ? (this.bumpTo(s), !0) : (this.bumpTo(this.message.length), !1);
    }, t.prototype.bumpTo = function(r) {
      if (this.offset() > r)
        throw Error("targetOffset ".concat(r, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (r = Math.min(r, this.message.length); ; ) {
        var i = this.offset();
        if (i === r)
          break;
        if (i > r)
          throw Error("targetOffset ".concat(r, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, t.prototype.bumpSpace = function() {
      for (; !this.isEOF() && X(this.char()); )
        this.bump();
    }, t.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var r = this.char(), i = this.offset(), s = this.message.charCodeAt(i + (r >= 65536 ? 2 : 1));
      return s ?? null;
    }, t;
  })()
);
function O(t) {
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
function ot(t) {
  return O(t) || t === 47;
}
function nt(t) {
  return t === 45 || t === 46 || t >= 48 && t <= 57 || t === 95 || t >= 97 && t <= 122 || t >= 65 && t <= 90 || t == 183 || t >= 192 && t <= 214 || t >= 216 && t <= 246 || t >= 248 && t <= 893 || t >= 895 && t <= 8191 || t >= 8204 && t <= 8205 || t >= 8255 && t <= 8256 || t >= 8304 && t <= 8591 || t >= 11264 && t <= 12271 || t >= 12289 && t <= 55295 || t >= 63744 && t <= 64975 || t >= 65008 && t <= 65533 || t >= 65536 && t <= 983039;
}
function X(t) {
  return t >= 9 && t <= 13 || t === 32 || t === 133 || t >= 8206 && t <= 8207 || t === 8232 || t === 8233;
}
function at(t) {
  return t >= 33 && t <= 35 || t === 36 || t >= 37 && t <= 39 || t === 40 || t === 41 || t === 42 || t === 43 || t === 44 || t === 45 || t >= 46 && t <= 47 || t >= 58 && t <= 59 || t >= 60 && t <= 62 || t >= 63 && t <= 64 || t === 91 || t === 92 || t === 93 || t === 94 || t === 96 || t === 123 || t === 124 || t === 125 || t === 126 || t === 161 || t >= 162 && t <= 165 || t === 166 || t === 167 || t === 169 || t === 171 || t === 172 || t === 174 || t === 176 || t === 177 || t === 182 || t === 187 || t === 191 || t === 215 || t === 247 || t >= 8208 && t <= 8213 || t >= 8214 && t <= 8215 || t === 8216 || t === 8217 || t === 8218 || t >= 8219 && t <= 8220 || t === 8221 || t === 8222 || t === 8223 || t >= 8224 && t <= 8231 || t >= 8240 && t <= 8248 || t === 8249 || t === 8250 || t >= 8251 && t <= 8254 || t >= 8257 && t <= 8259 || t === 8260 || t === 8261 || t === 8262 || t >= 8263 && t <= 8273 || t === 8274 || t === 8275 || t >= 8277 && t <= 8286 || t >= 8592 && t <= 8596 || t >= 8597 && t <= 8601 || t >= 8602 && t <= 8603 || t >= 8604 && t <= 8607 || t === 8608 || t >= 8609 && t <= 8610 || t === 8611 || t >= 8612 && t <= 8613 || t === 8614 || t >= 8615 && t <= 8621 || t === 8622 || t >= 8623 && t <= 8653 || t >= 8654 && t <= 8655 || t >= 8656 && t <= 8657 || t === 8658 || t === 8659 || t === 8660 || t >= 8661 && t <= 8691 || t >= 8692 && t <= 8959 || t >= 8960 && t <= 8967 || t === 8968 || t === 8969 || t === 8970 || t === 8971 || t >= 8972 && t <= 8991 || t >= 8992 && t <= 8993 || t >= 8994 && t <= 9e3 || t === 9001 || t === 9002 || t >= 9003 && t <= 9083 || t === 9084 || t >= 9085 && t <= 9114 || t >= 9115 && t <= 9139 || t >= 9140 && t <= 9179 || t >= 9180 && t <= 9185 || t >= 9186 && t <= 9254 || t >= 9255 && t <= 9279 || t >= 9280 && t <= 9290 || t >= 9291 && t <= 9311 || t >= 9472 && t <= 9654 || t === 9655 || t >= 9656 && t <= 9664 || t === 9665 || t >= 9666 && t <= 9719 || t >= 9720 && t <= 9727 || t >= 9728 && t <= 9838 || t === 9839 || t >= 9840 && t <= 10087 || t === 10088 || t === 10089 || t === 10090 || t === 10091 || t === 10092 || t === 10093 || t === 10094 || t === 10095 || t === 10096 || t === 10097 || t === 10098 || t === 10099 || t === 10100 || t === 10101 || t >= 10132 && t <= 10175 || t >= 10176 && t <= 10180 || t === 10181 || t === 10182 || t >= 10183 && t <= 10213 || t === 10214 || t === 10215 || t === 10216 || t === 10217 || t === 10218 || t === 10219 || t === 10220 || t === 10221 || t === 10222 || t === 10223 || t >= 10224 && t <= 10239 || t >= 10240 && t <= 10495 || t >= 10496 && t <= 10626 || t === 10627 || t === 10628 || t === 10629 || t === 10630 || t === 10631 || t === 10632 || t === 10633 || t === 10634 || t === 10635 || t === 10636 || t === 10637 || t === 10638 || t === 10639 || t === 10640 || t === 10641 || t === 10642 || t === 10643 || t === 10644 || t === 10645 || t === 10646 || t === 10647 || t === 10648 || t >= 10649 && t <= 10711 || t === 10712 || t === 10713 || t === 10714 || t === 10715 || t >= 10716 && t <= 10747 || t === 10748 || t === 10749 || t >= 10750 && t <= 11007 || t >= 11008 && t <= 11055 || t >= 11056 && t <= 11076 || t >= 11077 && t <= 11078 || t >= 11079 && t <= 11084 || t >= 11085 && t <= 11123 || t >= 11124 && t <= 11125 || t >= 11126 && t <= 11157 || t === 11158 || t >= 11159 && t <= 11263 || t >= 11776 && t <= 11777 || t === 11778 || t === 11779 || t === 11780 || t === 11781 || t >= 11782 && t <= 11784 || t === 11785 || t === 11786 || t === 11787 || t === 11788 || t === 11789 || t >= 11790 && t <= 11798 || t === 11799 || t >= 11800 && t <= 11801 || t === 11802 || t === 11803 || t === 11804 || t === 11805 || t >= 11806 && t <= 11807 || t === 11808 || t === 11809 || t === 11810 || t === 11811 || t === 11812 || t === 11813 || t === 11814 || t === 11815 || t === 11816 || t === 11817 || t >= 11818 && t <= 11822 || t === 11823 || t >= 11824 && t <= 11833 || t >= 11834 && t <= 11835 || t >= 11836 && t <= 11839 || t === 11840 || t === 11841 || t === 11842 || t >= 11843 && t <= 11855 || t >= 11856 && t <= 11857 || t === 11858 || t >= 11859 && t <= 11903 || t >= 12289 && t <= 12291 || t === 12296 || t === 12297 || t === 12298 || t === 12299 || t === 12300 || t === 12301 || t === 12302 || t === 12303 || t === 12304 || t === 12305 || t >= 12306 && t <= 12307 || t === 12308 || t === 12309 || t === 12310 || t === 12311 || t === 12312 || t === 12313 || t === 12314 || t === 12315 || t === 12316 || t === 12317 || t >= 12318 && t <= 12319 || t === 12320 || t === 12336 || t === 64830 || t === 64831 || t >= 65093 && t <= 65094;
}
export {
  Et as Parser
};
